import lrBarpercent from './_src/lrBarpercent.vue'

lrBarpercent.install = function(Vue) {
  Vue.component(lrBarpercent.name, lrBarpercent)
}

export default lrBarpercent